module.exports = __webpack_public_path__ + "img/tip3-small.25d36108.png";